import {customThemeConstants} from '@hconnect/uikit/src/lib2'
import {Grid} from '@mui/material'
import {QueryStatus} from '@tanstack/react-query'
import React, {ReactNode} from 'react'
import {useTranslation} from 'react-i18next'

import {DataFetchingPlaceholder} from '../components'
import {FEATURE_NAMESPACE} from '../consts'

import {ActionCardSkeleton} from './ActionsCardContainer'

interface SectionTopContainerProps {
  actionLoadingStatus: QueryStatus
  sideCardComponent: ReactNode
  children: ReactNode
  isLoading: boolean
}

export const SectionTopContainer: React.FC<SectionTopContainerProps> = ({
  actionLoadingStatus,
  sideCardComponent,
  isLoading,
  children
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <Grid container spacing={customThemeConstants().defaultGridSpacing}>
      <Grid item xs={12} md={6} xl={5}>
        {children}
      </Grid>
      <Grid item xs={12} md={6} xl={7}>
        {!isLoading ? (
          <>{sideCardComponent}</>
        ) : (
          <DataFetchingPlaceholder
            height="100%"
            loader={<ActionCardSkeleton />}
            isLoading={actionLoadingStatus === 'pending'}
            errorMessage={t('errors.actionsNotFetched')}
          />
        )}
      </Grid>
    </Grid>
  )
}
